import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";

import { noPaddingAllTypes } from "../../constants";
import { sumFormat } from "../../../lib/helpers/strings";

import Label from "../label";
import P from "../paragraph";

function getAvatarName(data) {
  if (data && Object.keys(data).length) {
    let avatarName = "";

    if (data.f && data.f.length) {
      avatarName += String(data.f).charAt(0);
    }

    if (data.i && data.i.length) {
      avatarName += String(data.i).charAt(0);
    }

    if (!avatarName.length) {
      if (data.username && data.username.length) {
        avatarName += String(data.username).charAt(0);
      }
    }

    return avatarName;
  } else {
    return "";
  }
}

function getUserTitle(data) {
  if (data && Object.keys(data).length) {
    let avatarName = "";

    if (data.f && data.f.length) {
      avatarName += data.f;
    }

    if (data.i && data.i.length) {
      avatarName += avatarName.length ? " " : "";
      avatarName += data.i;
    }

    return avatarName;
  } else {
    return "";
  }
}

function Card({
  type,
  data,
  withHover,
  up,
  to,
  style,
  padding,
  margin,
  shadow,
  className,
  onClick,
  children
}) {
  const classNameCard = classNames(
    "card",
    {
      [`type-${type}`]: type,
      [`padding-${padding}`]: padding,
      [`margin-${margin}`]: margin,
      [`card-${shadow}`]: shadow && (shadow >= 1 && shadow <= 5),
      up: up || (to && to.length),
      "with-hover": withHover || (to && to.length && type === "default")
    },
    className
  );

  let dataCard = data || {};
  let CardElement = null;

  switch (type) {
    case "user":
      // Если передали ссылку
      if (to && to.length) {
        CardElement = (
          <div className={classNameCard} style={style}>
            <Link to={to}>
              <div className="avatar">{getAvatarName(dataCard)}</div>
            </Link>

            <div className="info">
              <div className="title">
                <Link to={to}>{getUserTitle(dataCard)}</Link>
              </div>
              <div className="subtitle">
                <Link to={to}>@{dataCard.username || ""}</Link>
              </div>
            </div>
          </div>
        );
      } else {
        CardElement = (
          <div className={classNameCard} style={style} onClick={onClick}>
            <div className="avatar">{getAvatarName(dataCard)}</div>
            <div className="info">
              <div className="title">{getUserTitle(dataCard)}</div>
              <div className="subtitle">@{dataCard.username || ""}</div>
            </div>
          </div>
        );
      }

      break;

    case "shop":
      // Если передали ссылку
      if (to && to.length) {
        CardElement = (
          <div className={classNameCard} style={style}>
            <div className="info">
              <div className="title">
                <Link to={to}>{dataCard.title || ""}</Link>
              </div>
              <div className="bottom">
                <div className="start">
                  <Label slim={true} strong={true} size="x-small">
                    Начало дня
                  </Label>
                  <P margin="no">{sumFormat(dataCard.cashStartDay || 0)}</P>
                </div>
                <div className="end">
                  <Label slim={true} strong={true} size="x-small">
                    Конец дня
                  </Label>
                  <P margin="no">{sumFormat(dataCard.cashEndDay || 0)}</P>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        CardElement = (
          <div className={classNameCard} style={style} onClick={onClick}>
            <div className="info">
              <div className="title">{dataCard.title || ""}</div>
              <div className="bottom">
                <div className="start">
                  <Label slim={true} strong={true} size="x-small">
                    Начало дня
                  </Label>
                  <P margin="no">{sumFormat(dataCard.cashStartDay || 0)}</P>
                </div>
                <div className="end">
                  <Label slim={true} strong={true} size="x-small">
                    Конец дня
                  </Label>
                  <P margin="no">{sumFormat(dataCard.cashEndDay || 0)}</P>
                </div>
              </div>
            </div>
          </div>
        );
      }

      break;

    case "item":
      // Если передали ссылку
      if (to && to.length) {
        CardElement = (
          <div className={classNameCard} style={style}>
            <div className="info">
              <div className="title">
                <Link to={to}>{dataCard.title || ""}</Link>
              </div>
              <div className="subtitle">Штрихкод: {dataCard.barcode || ""}</div>
              <div className="bottom">
                <div className="out">
                  <Label slim={true} strong={true} size="x-small">
                    Розничная
                  </Label>
                  <P margin="no">{sumFormat(dataCard.priceOut || 0)}</P>
                </div>
                <div className="count">
                  <Label slim={true} strong={true} size="x-small">
                    Количество
                  </Label>
                  <P margin="no">{sumFormat(dataCard.count || 0)}</P>
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        CardElement = (
          <div className={classNameCard} style={style} onClick={onClick}>
            <div className="info">
              <div className="title">{dataCard.title || ""}</div>
              <div className="subtitle">Штрихкод: {dataCard.barcode || ""}</div>
              <div className="bottom">
                <div className="out">
                  <Label slim={true} strong={true} size="x-small">
                    Розничная
                  </Label>
                  <P margin="no">{sumFormat(dataCard.priceOut || 0)}</P>
                </div>
                <div className="count">
                  <Label slim={true} strong={true} size="x-small">
                    Количество
                  </Label>
                  <P margin="no">{sumFormat(dataCard.count || 0)}</P>
                </div>
              </div>
            </div>
          </div>
        );
      }

      break;

    default:
      // Если передали ссылку
      if (to && to.length) {
        let innerCard = React.createElement(
          "div",
          {
            className: classNameCard,
            style: style
          },
          children
        );

        CardElement = (
          <Link to={to} className="no-underline">
            {innerCard}
          </Link>
        );
      } else {
        CardElement = React.createElement(
          "div",
          {
            className: classNameCard,
            style: style,
            onClick
          },
          children
        );
      }

      break;
  }

  return CardElement;
}

Card.defaultProps = {
  type: "default",
  data: {},
  withHover: false,
  up: false,
  to: false,
  shadow: null,
  style: null,
  padding: null,
  margin: null,
  className: "",
  onClick: () => {},
  children: null
};

Card.propTypes = {
  type: PropTypes.oneOf(["user", "shop", "item", "default"]),
  data: PropTypes.object,
  withHover: PropTypes.bool,
  up: PropTypes.bool,
  to: PropTypes.oneOfType(PropTypes.string, PropTypes.bool),
  shadow: PropTypes.oneOf([1, 2, 3, 4, 5]),
  style: PropTypes.objectOf(
    PropTypes.oneOfType(PropTypes.string, PropTypes.number)
  ),
  padding: PropTypes.oneOf(noPaddingAllTypes),
  margin: PropTypes.oneOf(["no"]),
  className: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node
};

export default Card;
